// 21 ARD/IEP meeting sections (Texas) — used to drive guided meeting workflow.

export const IEP_SECTIONS = [
  {
    id: "opening",
    title: "1. Opening the Meeting",
    short: "Opening",
    points: [
      "Introductions of committee members",
      "Purpose of the meeting (Initial, Annual, Reevaluation, Revision, Transition, etc.)",
      "Confidentiality statement and procedural safeguards",
    ],
  },
  {
    id: "evaluation_data",
    title: "2. Review of Evaluation Data",
    short: "Evaluation Data",
    points: [
      "Full and Individual Evaluation (FIE) results",
      "Reevaluation data, if applicable",
      "Progress monitoring data",
      "Parent and teacher input",
      "Other relevant assessment information",
    ],
  },
  {
    id: "eligibility",
    title: "3. Eligibility Determination",
    short: "Eligibility",
    points: [
      "Review of disability category",
      "Confirmation that the student continues to meet eligibility criteria",
      "Determination of educational need for special education services",
    ],
  },
  {
    id: "special_factors",
    title: "4. Consideration of Special Factors",
    short: "Special Factors",
    points: [
      "Behavior and positive behavioral interventions/supports",
      "Limited English proficiency",
      "Communication needs",
      "Deaf or hard-of-hearing needs",
      "Braille needs for students with visual impairments",
      "Assistive technology needs",
    ],
  },
  {
    id: "plaafp",
    title: "5. Present Levels (PLAAFP)",
    short: "PLAAFP",
    points: [
      "Academic strengths and needs",
      "Functional strengths and needs",
      "Impact of disability on involvement and progress in the general curriculum",
      "Baseline data for goals",
    ],
  },
  {
    id: "goals",
    title: "6. Measurable Annual Goals & Objectives",
    short: "Goals",
    points: [
      "Annual goals",
      "Short-term objectives/benchmarks (required for alternate assessments; often included for others)",
      "Progress monitoring methods",
    ],
  },
  {
    id: "accommodations",
    title: "7. Accommodations, Modifications, & Supports",
    short: "Accommodations",
    points: [
      "Classroom accommodations",
      "Testing accommodations",
      "Supplementary aids and services",
      "Supports for school personnel",
    ],
  },
  {
    id: "assessments",
    title: "8. State & District Assessments",
    short: "Assessments",
    points: [
      "STAAR, STAAR Alternate 2, or other assessments",
      "Designated supports and accommodations",
      "Assessment decisions and justification",
    ],
  },
  {
    id: "transition",
    title: "9. Transition Planning (Age 14+, TX)",
    short: "Transition",
    points: [
      "Postsecondary goals",
      "Transition assessments",
      "Transition services and activities",
      "Course of study / graduation planning",
    ],
  },
  {
    id: "graduation",
    title: "10. Graduation Plan (Secondary)",
    short: "Graduation",
    points: [
      "Foundation High School Program participation",
      "Endorsements",
      "Distinguished Level of Achievement, if applicable",
      "Graduation requirements",
    ],
  },
  {
    id: "related_services",
    title: "11. Related Services",
    short: "Related Services",
    points: [
      "Speech therapy",
      "Occupational therapy",
      "Physical therapy",
      "Counseling",
      "Transportation",
      "Orientation and Mobility",
      "Other related services",
    ],
  },
  {
    id: "bip",
    title: "12. Behavior Intervention Plan (BIP)",
    short: "BIP",
    points: [
      "Review or development of BIP if needed",
      "Consideration of Functional Behavioral Assessment (FBA)",
    ],
  },
  {
    id: "assistive_tech",
    title: "13. Assistive Technology",
    short: "Assistive Tech",
    points: [
      "Consideration and determination of AT needs",
      "Devices and services required",
    ],
  },
  {
    id: "esy",
    title: "14. Extended School Year (ESY)",
    short: "ESY",
    points: [
      "Review of regression / recoupment data",
      "Determination of ESY eligibility",
    ],
  },
  {
    id: "lre",
    title: "15. Least Restrictive Environment (LRE)",
    short: "LRE",
    points: [
      "Discussion of placement options",
      "Explanation of removal from general education, if any",
      "Participation with nondisabled peers",
    ],
  },
  {
    id: "services",
    title: "16. Determination of Services",
    short: "Services",
    points: [
      "Special education services",
      "Frequency, duration, and location",
      "Beginning and ending dates",
    ],
  },
  {
    id: "placement",
    title: "17. Placement Determination",
    short: "Placement",
    points: [
      "Specific instructional setting",
      "Percentage of time in general education and special education settings",
    ],
  },
  {
    id: "shars",
    title: "18. SHARS Information",
    short: "SHARS",
    points: [
      "Parent notification and consent as required for Medicaid reimbursement",
    ],
  },
  {
    id: "safeguards",
    title: "19. Procedural Safeguards & Assurances",
    short: "Safeguards",
    points: [
      "Parent rights reviewed",
      "Questions addressed",
    ],
  },
  {
    id: "deliberations",
    title: "20. Deliberations & Consensus",
    short: "Deliberations",
    points: [
      "Summary of committee discussion",
      "Decisions made",
      "Parent concerns and responses",
    ],
  },
  {
    id: "closure",
    title: "21. Signatures & Meeting Closure",
    short: "Closure",
    points: [
      "Documentation of attendance",
      "Agreement / disagreement",
      "Notice of ARD recommendations",
    ],
  },
];

export const SECTION_BY_ID = Object.fromEntries(IEP_SECTIONS.map((s) => [s.id, s]));
